import {toggle} from 'slidetoggle';
import {realpressContactFormSendEmail} from '../mixins/contact-form';

const realpressContactForm = () => {
    const contactFormNodes = document.querySelectorAll('.realpress-single-property-contact-form');
    if (!contactFormNodes) {
        return;
    }
    for (let i = 0; i < contactFormNodes.length; i++) {
        const contactFormNode = contactFormNodes[i];
        const formNode = contactFormNode.querySelector('form');
        if (!formNode) {
            return;
        }
        contactFormNode.querySelector('.realpress-agent-detail i').addEventListener('click', function () {
            console.log('aaa');
            toggle(formNode, {
                miliseconds: 300,
            });
        });

        realpressContactFormSendEmail(formNode);
    }
};

export default realpressContactForm;
